import Orderpoint from '@/pages/Orderpoint/Template'
import Cart from '@/pages/Orderpoint/Cart'
import Checkout from '@/pages/Orderpoint/Checkout'
import Orders from '@/pages/Orderpoint/Orders'
import Order from '@/pages/Orderpoint/Order'
export default {
    path: '',
    component: Orderpoint,
    children: [
        {
            path: '/cart',
            name: 'Cart',
            component: Cart,
        },
        {
            path: '/checkout',
            name: 'Checkout',
            component: Checkout,
        },
        {
            path: '/checkout/:ckid',
            name: 'CheckoutOrderURL',
            component: Checkout,
        },
        {
            path: '/checkout/re/:rmkoref',
            name: 'CheckoutOrderRemake',
            component: Checkout,
        },
        {
            path: '/orders',
            name: 'Orders',
            component: Orders,
        },
        {
            path: '/order',
            name: 'Order',
            component: Order,
        },
    ]
}


// WEBPACK FOOTER //
// ./src/router/orderpoint.js